import React, {Component} from "react";
import UserLinkHeader from "./UserLinkHeader";
import TakemoneyItems from "./Takemoney/TakemoneyItems";
import TakemoneyItem from "./Takemoney/TakemoneyItem";
import BANKS from "../../constants/banks";
import ByBankForm from "./Takemoney/Form/ByBankForm";
import ByPpsForm from "./Takemoney/Form/ByPpsForm";
import ByInvestbank from "./Takemoney/Form/ByInvestbank";
import $ from 'jquery';
import ByMobile from "./Takemoney/Form/ByMobile";
import {LOCAL} from "../../constants/local";

class UserTakemoney extends Component {
	state = {
		activeBank       : {},
		activeOffice     : {},
		activeType       : {},
		isPpsOpen        : false,
		isInvestbankOpen : false,
		isMobileOpen     : false,
	};

	banks = [];

	constructor(props) {
		super(props);
		this.banks = BANKS;
	}

	componentWillMount() {
		this.setActiveBank(0);
	}

	changeBank(bank_id) {
		this.setActiveBank(bank_id - 1);
		$('html, body').animate({scrollTop : $(this.refs.byBank).offset().top}, 500);
	}

	setActiveBank(id) {
		const bank = this.banks[id];
		this.setState({
			activeBank   : bank,
			activeOffice : bank.offices[0],
			activeType   : bank.type[0]
		});
	}

	changeOffice(e) {
		const office = this.state.activeBank.offices.filter((office) => {return office.id === parseInt(e.target.value)});

		this.setState({
			activeOffice : office[0]
		})
	}

	changeType(e) {
		const type = this.state.activeBank.type.filter((t) => {return t.id === parseInt(e.target.value)});

		this.setState({
			activeType : type[0]
		});
	}

	ppsOrder() {
		this.setState({
			isPpsOpen : !this.state.isPpsOpen
		});
	}

	investOrder() {
		this.setState({
			isInvestbankOpen : !this.state.isInvestbankOpen
		});
	}

	mobileOrder() {
		this.setState({
			isMobileOpen : !this.state.isMobileOpen
		});
	}

	render() {
		const activeBank = this.state.activeBank;

		return (
			<div className="news">
				<UserLinkHeader/>

				<div className="cash-in-out">
					<TakemoneyItems title={'Заказ на снятие денег'}>
						<div className="table__row data">
							<div className="table__column payment-type">
								<i className="fas fa-map-marker-alt"></i>
								<span>Пункты приема ставок</span>
							</div>
							<div className="table__column comission">0%</div>
							<div className="table__column in-processing">24 часа</div>
							<div className="table__column min-sum">1 {LOCAL.currency}</div>
							<div className="table__column actions">
								<div className="buttons">
									<button className="buttons__show" onClick={this.ppsOrder.bind(this)}>
										Заказать выплату
									</button>
								</div>
							</div>
						</div>
						<div className={`description by-bank ${this.state.isPpsOpen && 'show'}`}>
							<ByPpsForm/>
						</div>
					</TakemoneyItems>
				</div>
			</div>
		);
	}
}

export default UserTakemoney;


// WEBPACK FOOTER //
// ./src/app/pages/User/UserTakemoney.js